module.exports = __webpack_public_path__ + "static/ice_coffee@2x-bd513dad9965cf1ccfdd03d3421bb50f.png";